import React, { useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import InputField from "../../components/Input";
import { useForm } from "react-hook-form";
import AuthServices from "../../../services/Auth";
import { emailRegex } from "../../../utils";
import dayjs from "dayjs";
import { ErrorToaster, SuccessToaster } from "../../components/toaster/Toaster";
import { Spinner } from "react-bootstrap";

const ForgotPassword = () => {

  const route = all_routes;
  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);

  // *For Forgot Password
  const forgotPassword = async (formData) => {
    setLoading(true)
    try {
      const obj = {
        email: formData?.email,
      }
      const { message } = await AuthServices.forgotPassword(obj)
      SuccessToaster(message)
      navigate(route.signin)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper login-new">
          <div className="container">
            <div className="login-content user-login">
              <div className="login-logo">
                <ImageWithBasePath src="assets/img/logo.png" alt="img" className="mb-2" />
              </div>
              <form style={{ width: '45%' }} onSubmit={handleSubmit(forgotPassword)}>
                <div className="login-userset">
                  <div className="login-userheading">
                    <h3>Forgot password?</h3>
                    <h4>
                      If you have forgotten your password, please enter your email address below and we will send you a link to reset your password.
                    </h4>
                  </div>
                  <div className="add-product mb-3">
                    <InputField
                      label="Email Address"
                      type="email"
                      endAdornment={
                        <ImageWithBasePath
                          src="assets/img/icons/mail.svg"
                          alt="img"
                        />
                      }
                      error={errors?.email?.message}
                      register={register("email", {
                        required: 'Please enter your email.',
                        pattern: {
                          value: emailRegex,
                          message: 'Please enter a valid email.',
                        }
                      })}
                    />
                  </div>
                  <div className="form-login">
                    <button
                      className="btn btn-login"
                      type="submit"
                      disabled={loading}
                    >
                      {loading &&
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                      }
                      Send Link
                    </button>
                  </div>
                  <div className="signinform text-center">
                    <h4>
                      Return to
                      <Link to={route.signin} className="hover-a">
                        {" "}
                        login{" "}
                      </Link>
                    </h4>
                  </div>
                </div>
              </form>
            </div>
            <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
              <p>Copyright © {dayjs().format('YYYY')} Slynx Technologies. All rights reserved</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
